<template>
  <adivare-input
    @validation-request="validateField"
    :outer-class="outerClass"
    :input-class="inputClass"
    :legend-class="legendClass"
    :show-property="showProperty"
    :label-class="labelClass"
    :property-name="propertyName"
    :placeholder="fieldLabel"
    form-type="text"
    :field-label="fieldLabel"
    :optional="optional"
    :custom-error-message="errorMessage"
  />
</template>

<script>
import IBAN from '../../../../../js/vendor/iban/iban';
import formMixin from "../../../mixins/form-mixin";
import { empty } from "../../../../../js/util/util-functions";
export default {
  name: "adivare-iban-form-element",
  mixins: [
    formMixin,
  ],
  computed: {
    payment() {
      const selectedPaymentId = this.$store.getters.getSelectedPaymentId;
      return this.$store.getters.getPayments[selectedPaymentId];
    },
    showProperty() {
      const show = this.$store.getters.totalPrice > 0;
      this.validateField(this.fieldValue, show);

      return show;
    },
    errorMessage() {
      return false === empty(this.fieldValue) ?
        this.$t('messages_nl.label.cancellation.userLetter.iban.error') :
        this.$t('messages_nl.global.required');
    },
    fieldValue() {
      return this.$store.getters.getPaymentTypeField('iban');
    },
  },
  created() {
    // Initialize the iban field to valid when we are not showing it.
    if (false === this.showProperty) {
      this.$store.commit('updatePaymentTypeValidity', {
        name: this.propertyName,
        valid: true,
      });
    }
  },
  methods: {
    validateField(value, showProperty) {
      this.$store.commit('updatePaymentTypeValidity', {
        name: this.propertyName,
        valid: !showProperty || IBAN.isValid(value)
      });
    },
  },
}
</script>
